import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.summary.colleaguesOnly',
    value: 'colleagues-only',
  },
  { title: 'pages.onboarding.summary.handful', value: 'handful' },
  { title: 'pages.onboarding.summary.solid', value: 'solid' },
  { title: 'pages.onboarding.summary.wellConnected', value: 'well-connected' },
  {
    title: 'pages.onboarding.summary.knownConnector',
    value: 'known-connector',
  },
]

export default function SummaryPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.summary.title"
      layout="grid"
    />
  )
}
